import { useNavigate, useParams } from "react-router-dom";
import Header from "../HeaderFooter/Header";
import Footer from "../HeaderFooter/Footer";
import { useEffect, useState } from "react";
import { getServiceCallByID } from "../../services/API";
import "../../styles/projectStyles/ServiceDetails.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const ServiceCallDetails = ({
  activeTab,
  setActiveTab,
  tabsTitle = "Service Call",
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [serviceCallId, setServiceCallId] = useState("");
  const [serviceCallDescription, setServiceCallDescription] = useState("");
  const [address, setAddress] = useState("");
  const [postCode, setPostCode] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [siteStatus, setSiteStatus] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [status, setStatus] = useState("");
  const [taskName, setTaskName] = useState("");
  const [employeesAssigned, setEmployeesAssigned] = useState([]);
  const [subtasks, setSubtaskName] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [timeframe, setTimeframe] = useState({});
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    const fetchServiceCall = async () => {
      try {
        const response = await getServiceCallByID(id);

        if (response && response.data) {
          // const { dataD, Tasks, Timeframe, Attachments } = response.data;

          // setTimeframe(Timeframe[0]);
          // setAttachments(Attachments);

          const data = response.data;
          console.log("response.data new", response.data);
          // Set individual values
          setServiceCallId(data.serviceCallId);
          setServiceCallDescription(data.serviceCallDescription);
          setAddress(data.address);
          setPostCode(data.postCode);
          setContactPhone(data.contactPhone);
          setContactEmail(data.contactEmail || "N/A");
          setSiteStatus(data.siteStatus);
          setCreatedAt(data.createdAt);
          setUpdatedAt(data.updatedAt);
          setStatus(data.status);
          setTaskName(data.task.taskName);
          setEmployeesAssigned(data.task.employeesAssigned || []);
          setSubtaskName(data.task.subtasks);
          setFirstName(data.Contact_First_Name);
          setLastName(data.Contact_Last_Name);
          setTasks(data.task);
        } else {
          console.error("Invalid API response");
        }
      } catch (error) {
        console.error("Error fetching service call details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServiceCall();
  }, [id]);
  const handleEditBtn = () => {
    // Clear localStorage data
    localStorage.removeItem("serviceData");
    localStorage.removeItem("selectedTasks");
    localStorage.removeItem("dateRanges");

    // Transform and save service call data to localStorage
    const serviceCallData = {
      address: address || "",
      postCode: postCode || "",
      contactPhone: contactPhone || "",
      contactEmail: contactEmail || "",
      serviceCallDescription: serviceCallDescription || "",
      firstName: firstName || "",
      lastName: lastName || "",
      siteStatus: siteStatus || "Offsite",
    };

    localStorage.setItem("serviceData", JSON.stringify(serviceCallData));
    localStorage.setItem("serviceId", id);

    const selectedTasksTrf = [
      {
        taskid: tasks.taskId,
        taskname: tasks.taskName,
        subtasklist: tasks.subtasks?.map((subtask) => ({
          value: subtask.subtaskId || "",
          label: subtask.subtaskName,
        })),
        employeelist: tasks.employeesAssigned?.map((employee) => ({
          value: employee.employeeId,
          label: employee.employeeName,
        })),
      },
    ];
    console.log("selectedTasksTrf", selectedTasksTrf);
    localStorage.setItem("selectedTasks", JSON.stringify(selectedTasksTrf));

    // Transform and save tasks data
    function formatDateString(dateString) {
      console.log("Date before edit", dateString);
      const formattedDate =
        dayjs.utc(dateString).format("YYYY-MM-DDTHH:mm:ss.SSS") + "-05:00";
      console.log("Date after edit", formattedDate);
      return formattedDate;
    }
    function formatToStartTime(dateString) {
      const date = new Date(dateString);

      // Format the time without changing the original time
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC", // Ensure the time is not shifted
      });
    }
    const employeesTrf = {
      [tasks.taskId]: tasks.employeesAssigned.map((employee) => ({
        startDate: formatDateString(employee.timeStart),
        endDate: formatDateString(employee.timeFinish),
        startTime: formatToStartTime(employee.timeStart),
        endTime: formatToStartTime(employee.timeFinish),
      })),
    };

    console.log("dateRanges ", employeesTrf);
    localStorage.setItem("dateRanges", JSON.stringify(employeesTrf));

    // Navigate to the edit page
    navigate("/newservicecall");
  };

  const handleCreateNewProjectClick = () => {
    if (setActiveTab) setActiveTab("Service Call Details");
    navigate("/servicecall");
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!serviceCallId) {
    return <div>Error: Service call not found</div>;
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    ).toLocaleDateString();
  };

  const startDates =
    employeesAssigned.length > 0
      ? formatDate(employeesAssigned[0].timeStart)
      : "N/A";

  const endDates =
    employeesAssigned.length > 0
      ? formatDate(employeesAssigned[0].timeFinish)
      : "N/A";

  const files = [
    {
      image: "/images/doc.svg",
      name: "Construction Doc 1",
      size: "2mb",
      progress: 70,
    },
    {
      image: "/images/video.svg",
      name: "Construction Video 2",
      size: "20mb",
      progress: 25,
    },
    {
      image: "/images/image.svg",
      name: "Construction Image 3",
      size: "5mb",
      progress: 40,
    },
    {
      image: "/images/doc.svg",
      name: "Construction Doc 4",
      size: "2mb",
      progress: 95,
    },
  ];

  const openGoogleMaps = (address) => {
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps?q=${encodedAddress}`;
    window.open(mapsUrl, "_blank");
  };

  return (
    <div className="details-project-container">
      <Header />
      <div className="project_details">
        <div className="det-container">
          <h2 className="servicecall-details-title">{tabsTitle}</h2>
          <div className="detail">
            <button
              className={`detail-item ${
                activeTab === "Service Call Details" ? "active" : ""
              }`}
              onClick={handleCreateNewProjectClick}
            >
              <img
                src="/images/back.svg"
                alt="New Project Icon"
                className="tab-icon"
              />
              Service Call Details
            </button>
            <img
              src="/images/Rectangle.png"
              alt="New Project Icon"
              className="rectan-icon"
            />
          </div>
        </div>
      </div>

      <div className="detailScreen">
        <div className="project-date-card">
          <div className="date-section">
            <div className="date">
              <p className="date-label">Start Date</p>
              <p className="date-value">{startDates}</p>
            </div>
            <div className="date">
              <p className="date-label">End Date</p>
              <p className="date-value">{endDates}</p>
            </div>
          </div>
          <div className="status-section">
            <span className="status-icon">
              <img
                src="/images/progress.png"
                alt="progress"
                className="pro-icon"
              />
            </span>{" "}
            {/* You can replace this with an icon component if needed */}
            <span className="status-text">{status}</span>
          </div>
        </div>
        <div className="pro-details-container">
          <div className="address-container">
            <h3 className="pro-title">{address}</h3>
            <button className="edit-btn" onClick={handleEditBtn}>
              <img src="/images/edit.png" alt="Edit" className="edit-icon" />
              Edit
            </button>
          </div>
          <div className="pro-container">
            {/* Project Description */}
            <div className="pro-desc-container">
              <h3 className="prodesc-title">Service Call Description</h3>
              <div className="prodetails-container">
                <div className="details-wrapper">
                  <table className="prodet-table">
                    <thead>
                      <tr>
                        <th>House Details</th>
                        <th></th>
                        <th>Contact Details</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Address</strong>
                          <br />
                          {address}
                        </td>
                        <td>
                          <strong>Postal Code</strong>
                          <br />
                          {postCode}
                        </td>
                        <td>
                          <strong>First Name</strong>
                          <br />
                          {firstName}
                        </td>
                        <td>
                          <strong>Last Name</strong>
                          <br />
                          {lastName}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2">
                          <h3 className="overview">Project Overview</h3>
                          <p className="project-overview">
                            {serviceCallDescription}
                          </p>
                        </td>
                        <td>
                          <strong>Phone Number</strong>
                          <br />
                          {contactPhone}
                        </td>

                        <td>
                          <strong>Email Address</strong>
                          <br />
                          {contactEmail}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="taskanddates-detail-container">
              <h3 className="prodesc-title">Task and Dates</h3>
              <div className="prodetails-container">
                <table className="taskdate-table">
                  <tbody>
                    <tr className="task-title">
                      <td colSpan="2">{taskName}</td>
                    </tr>
                    <tr>
                      <td className="task-details">
                        <div>
                          {subtasks.length > 0 ? (
                            <ul>
                              {subtasks.map((subtask, index) => (
                                <li key={index}>
                                  {subtask.subtaskName || "Unnamed Subtask"}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p>No subtasks assigned</p>
                          )}
                        </div>
                      </td>
                      <td className="team-data">
                        <div className="teams-container">
                          {employeesAssigned.map((employee) => (
                            <div className="teams" key={employee.employeeId}>
                              <span className="employeeNameSpan">
                                {employee.employeeName}
                              </span>

                              <span>{startDates}</span>

                              <span>{endDates}</span>

                              <img
                                src="/images/location.png"
                                alt="Time Icon"
                                className="location-icon"
                                onClick={() => openGoogleMaps(address)}
                              />
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Additional Details */}
            <div className="additionaldet-container">
              <h3 className="prodesc-title">Additional Details</h3>
              <div className="additionaldetls">
                <h3 className="attach">Attachments</h3>
                <div className="file-list">
                  {files.length > 0 ? (
                    files.map((file, index) => (
                      <div key={index} className="file-item">
                        <img
                          src={file.image || "images/doc.svg"}
                          alt={`${file.name} preview`}
                          className="file-preview"
                        />
                        <span className="file-name">{file.name}</span>
                        <span className="file-size">{file.size}</span>
                        <img
                          src="/images/downloads.png"
                          alt="Download Icon"
                          className="location-icon"
                        />
                      </div>
                    ))
                  ) : (
                    <p>No files uploaded</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceCallDetails;
